var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"feature_welcome"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"inner"},[_c('div',{staticClass:"content"},[(_vm.featureTitle)?_c('h1',{domProps:{"innerHTML":_vm._s(_vm.featureTitle)}}):_vm._e(),_vm._v(" "),(_vm.featureCopy)?_c('div',{staticClass:"copy",domProps:{"innerHTML":_vm._s(_vm.featureCopy)}}):_vm._e()])])])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/cpmec.stagingwebsite.dev/web/app/themes/cpmec/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/cpmec.stagingwebsite.dev/web/app/themes/cpmec/node_modules/vue-loader/lib?{}!./scripts/vue/FeatureWelcome.vue?vue&type=template&id=65ba74b7&scoped=true&
// module id = 252
// module chunks = 0